import DeviationListTable from './DeviationListTable';

export default DeviationListTable;
